import './ParticipantsList.scss';

import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from 'src/store';
import { CardEvent, Station } from 'src/store/events/types';
import { deleteParticipant, updateParticipant } from 'src/store/participant/actions';
import { Participation } from 'src/store/participant/types';
import { User } from 'src/store/user/types';
import { IconPaths } from 'src/icons';
import SuggestUser from '../AddParticipant/SuggestUser';

interface Props {
  participations?: Participation[];
  event?: CardEvent;
  deleteParticipant: typeof deleteParticipant;
  updateParticipant: typeof updateParticipant;
  user: User;
}

interface State {
  value: any;
  selected?: number;
  type: string;
}

class ParticipantsList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      value: {},
      selected: undefined,
      type: ''
    };
  }

  onEdit = (part: Participation) => {
    if (!!this.props.event && this.props.event.bikesAllowed && part.bike == null) {
      part.bike = { type: 'bike', space: 1 };
    }
    this.setState(
      prevState => {
        return {
          ...prevState,
          selected: part.id,
          value: { ...part }
        };
      },
      () => {
        console.log(this.state.value);
      }
    );
  };

  onDelete = (partId: number) => {
    this.props.deleteParticipant(partId);
  };

  public render() {
    const { event, participations, user } = this.props;

    return (
      <div className="participantsList">
        {/* <div className="partListHeader" style={{ position: 'relative' }}>
          <h2>Teilnehmer</h2>

        </div> */}
        <table className="styledTable">
          <thead>
            <tr>
              <th>Nr.</th>
              <th>Vorname</th>
              <th>Nachname</th>
              <th>Telefonummer</th>
              <th>Erw/Kind</th>
              {event && event.bikesAllowed && <th>Radtyp</th>}
              {event && event.buses && event.buses.length > 0 && <th>Station</th>}
              <th>Betrieb</th>
              <th>Karte</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {event &&
              participations &&
              participations
                .sort((a: Participation, b: Participation) =>
                  a.id < b.id ? -1 : a.id > b.id ? 1 : 0
                )
                .map((participation: Participation, i: number) => {
                  const participant = participation.participant;
                  if (participant) {
                    if (this.state.selected === participation.id) {
                      return this.partEdit(i, participation, event, user);
                    }
                    return this.partItem(i, participation, event);
                  } else {
                    return null;
                  }
                })}
          </tbody>
        </table>
      </div>
    );
  }

  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const name = e.target.name;

    const split = name.split('.');

    this.setState(
      prevState => {
        return {
          ...prevState,
          value: {
            ...prevState.value,
            [split[0]]: {
              ...prevState.value[split[0]],
              [split[1]]: inputValue
            }
          }
        };
      },
      () => {
        console.log(this.state.value);
      }
    );
  };

  onChangeSelect = (e: any) => {
    const inputValue = e.target.value;
    const name = e.target.name;

    if (inputValue === 'adult') {
      this.setState(prevState => {
        return {
          ...prevState,
          value: {
            ...prevState.value,
            participant: {
              ...prevState.value.participant,
              isChild: false,
              age: undefined
            }
          }
        };
      });
    } else if (inputValue === 'child') {
      this.setState(prevState => {
        return {
          ...prevState,
          value: {
            ...prevState.value,
            participant: {
              ...prevState.value.participant,
              isChild: true,
              age: -1
            }
          }
        };
      });
    } else if (name === 'bikeType') {
      this.setState(prevState => {
        return {
          ...prevState,
          value: {
            ...prevState.value,
            bike: {
              type: inputValue
            }
          }
        };
      });
    } else if (name === 'station') {
      const station =
        this.props.event &&
        this.props.event.buses &&
        this.props.event.buses[0].stations &&
        this.props.event.buses[0].stations.find(x => x.id === +inputValue);

      console.log('SODJIFJIOSDFJIOS');
      console.log(station);
      this.setState(prevState => {
        return {
          ...prevState,
          value: {
            ...prevState.value,
            station
          }
        };
      });
    }
  };

  partItem = (i: number, parti: Participation, cardevent: CardEvent) => {
    return (
      <tr key={i}>
        <td>{i + 1}</td>
        <td>{parti.participant.firstname}</td>
        <td>{parti.participant.lastname}</td>
        <td>{parti.participant.phonenumber}</td>
        <td>
          {parti.participant.isChild
            ? parti.participant.age
              ? parti.participant.age !== -1
                ? 'Kind ' + parti.participant.age
                : 'Kind'
              : 'Kind'
            : 'Erwachsener'}
        </td>
        {cardevent.bikesAllowed && (
          <td>
            {!parti.bike
              ? null
              : parti.bike.type === 'bike'
              ? 'Bike'
              : parti.bike.type === 'ebike'
              ? 'E-Bike'
              : null}
          </td>
        )}
        {cardevent.buses && cardevent.buses.length > 0 ? (
          <td>
            {parti.station &&
              parti.station.place &&
              parti.station.place + ' - ' + parti.station.time}
          </td>
        ) : null}
        <td>{parti.participant.creator && parti.participant.creator.name}</td>
        <td>
          {parti.participant.isStaff ? <span>Mitarbeiterkarte</span> : <span>Gästekarte</span>}
        </td>
        <td>
          {this.props.user.role.canManageParticipants && (
            <React.Fragment>
              <img
                src={IconPaths['bin-icon']}
                title="Löschen"
                onClick={this.onDelete.bind(this, parti.id)}
              />
              <img
                src={IconPaths['edit-icon']}
                title="Editieren"
                onClick={this.onEdit.bind(this, parti)}
              />
            </React.Fragment>
          )}
        </td>
      </tr>
    );
  };

  partEdit = (i: number, parti: Participation, cardevent: CardEvent, user: User) => {
    return (
      <tr key={i}>
        <td>{i + 1}</td>
        <td>
          <input
            type="text"
            value={this.state.value.participant.firstname}
            name="participant.firstname"
            onChange={this.onChange}
          />
        </td>
        <td>
          <input
            type="text"
            value={this.state.value.participant.lastname}
            name="participant.lastname"
            onChange={this.onChange}
          />
        </td>
        <td>
          <input
            type="text"
            value={this.state.value.participant.phonenumber}
            name="participant.phonenumber"
            onChange={this.onChange}
          />
        </td>
        <td>
          <select
            value={this.state.value.participant.isChild ? 'child' : 'adult'}
            onChange={this.onChangeSelect}
          >
            <option value="adult">Erwachsener</option>
            <option value="child">Kind</option>
          </select>
          {this.state.value.participant.isChild && (
            <input
              type="number"
              value={this.state.value.participant.age > 0 ? this.state.value.participant.age : ''}
              onChange={this.onChange}
              name="participant.age"
            />
          )}
        </td>
        {/* {cardevent.bikesAllowed && (
          <td>
            {parti.bike === undefined
              ? null
              : parti.bike.type === 'bike'
              ? 'Bike'
              : parti.bike.type === 'ebike'
              ? 'E-Bike'
              : null}
          </td>
        )} */}
        {cardevent.bikesAllowed && (
          <td>
            <select
              value={
                !!this.state.value.bike && !!this.state.value.bike.type
                  ? this.state.value.bike.type
                  : 'bike'
              }
              onChange={this.onChangeSelect}
              name="bikeType"
            >
              <option value="bike">Bike</option>
              <option value="ebike">E-Bike</option>
            </select>
          </td>
        )}
        {cardevent.buses && cardevent.buses.length > 0 ? (
          <td>
            <select
              name="station"
              onChange={this.onChangeSelect}
              value={this.state.value.station && this.state.value.station.id}
            >
              {cardevent.buses[0].stations &&
                cardevent.buses[0].stations.map((station: Station, index: number) => (
                  <option key={index} value={station.id}>
                    {station.place} - {station.time}
                  </option>
                ))}
            </select>
          </td>
        ) : null}
        <td>
          {user.role.canUpdateUser ? (
            <SuggestUser
              errorClassName={null}
              placeholder={this.state.value.participant.creator.name}
              value={this.state.value.participant.creator}
              type="business"
              onBlur={null}
              onSelected={(u: User) => {
                this.onBusinessChanged(u);
              }}
            />
          ) : (
            <span>{user.name}</span>
          )}
        </td>
        <td>
          {parti.participant.isStaff ? <span>Mitarbeiterkarte</span> : <span>Gästekarte</span>}
        </td>
        <td>
          <button onClick={this.onUpdate} className="noStyle">
            <img src={IconPaths['save-icon']} title="Speichern" />
          </button>
          <button onClick={this.onCancel} className="noStyle">
            <img src={IconPaths['cancel-icon']} title="Abbrechen" />
          </button>
          {/* <img src={IconPaths['bin-icon']} onClick={this.onDelete.bind(this, parti.id)} />
          <img src={IconPaths['edit-icon']} onClick={this.onEdit.bind(this, parti.participant)} /> */}
        </td>
      </tr>
    );
  };

  onBusinessChanged = (user: User) => {
    this.setState(
      prevState => {
        return {
          ...prevState,
          value: {
            ...prevState.value,
            participant: {
              ...prevState.value.participant,
              creator: user
            }
          }
        };
      },
      () => {
        console.log(this.state.value);
      }
    );
  };

  onCancel = () => {
    this.setState({ selected: undefined });
  };

  onUpdate = () => {
    const participation = this.state.value;
    console.log('Updated participation', participation);
    if (this.props.event) {
      participation.cardevent = {
        id: this.props.event.id
      };
      this.props.updateParticipant(this.state.value);
      this.onCancel();
    }
  };
}

const mapStateToProps = ({ auth }: ApplicationState) => ({
  user: auth.data
});

const mapDispatchToProps = (dispatch: any) => ({
  updateParticipant: (participation: Participation) => dispatch(updateParticipant(participation)),
  deleteParticipant: (partId: number) => dispatch(deleteParticipant(partId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ParticipantsList);



// WEBPACK FOOTER //
// ./src/pages/Event/EventDetail/ParticipantsList/ParticipantsList.tsx